import {createRoot} from 'react-dom/client';
import './styles/main.css';
import App from "./App";
import {gsap} from "gsap";
import {useGSAP} from '@gsap/react';
import * as Sentry from "@sentry/react";

gsap.registerPlugin(useGSAP);

Sentry.init({
    dsn: "https://bad55b7e79bd3a3ca27a42c271a75a13@o4507527044661248.ingest.us.sentry.io/4511134290935808",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Enable logs to be sent to Sentry
    enableLogs: true
});


window.ein = window.ein || []
window.ein.content = JSON.parse(document.getElementById('ein-content').textContent)

const meta = document.createElement('meta');
meta.name = "theme-color";
meta.content = "#EF8B22";
document.querySelector('head').appendChild(meta);

const root = createRoot(document.getElementById('ein-booking-form'));
root.render(<App/>);
